import axios from 'axios';
import { variables } from '../Variables';

export const mergeAnswerInOrginalEstateConfigObj = (orginalQuestionDocObj, waitingListQuestionArr) => {

    let updatedQuestions = orginalQuestionDocObj.questions.map(orginalQuesAnsObjItem => {

        // filter match ids from both array
        let questionAnsIdsMatch = waitingListQuestionArr.questions.find(waitingListItem => waitingListItem.questionId == orginalQuesAnsObjItem.questionId);

        //let orginalQuestionObjConvertParse = JSON.parse(orginalQuesAnsObjItem.questionDetail);

        if (questionAnsIdsMatch != undefined && questionAnsIdsMatch.answerText != undefined && questionAnsIdsMatch.answerText != "") {
            orginalQuesAnsObjItem.answerText = questionAnsIdsMatch.answerText;
            orginalQuesAnsObjItem.answerId = questionAnsIdsMatch.answerId;
        }

        return { ...orginalQuesAnsObjItem }

       // return { ...orginalQuesAnsObjItem, questionDetail: JSON.stringify(orginalQuestionObjConvertParse) }

    })

    let updatedDocuments = orginalQuestionDocObj.requiredDocuments.map(documentsItem => {

        // filter match ids from both array
        let documentsIdsMatch = waitingListQuestionArr.requiredDocuments.find(docItem => docItem.id == documentsItem.id);

        return {
            ...documentsItem,
            documentImageUrl: documentsIdsMatch && documentsIdsMatch.documentImageUrl != null ? documentsIdsMatch.documentImageUrl : documentsItem.documentImageUrl
        };

    })

    return {
        ...orginalQuestionDocObj,
        questions: updatedQuestions,
        requiredDocuments: updatedDocuments
    }
}

export const questionOrderSort = (estateConfig) => {

    let updateObjectQuestionOrder = {
        ...estateConfig,
        questions: estateConfig.questions.sort((a, b) => a.order - b.order)
    }

    return updateObjectQuestionOrder;
}

export const getIpAddress = async () => {

    try {
        const url = "https://api.ipify.org?format=json"

        const response = await axios.get(url);

        if (response.data) {
            return response.data.ip;
        }
    } catch (error) {
        console.log(error);
    }
}

export const queryParamObj = (queryParams) => {

    let firstName = "";
    let name = "";
    let email = "";
    let mobile = "";

    if (queryParams && Object.keys(queryParams).length > 0) {
        // Convert queryParams keys to lowercase
        const normalizedParams = Object.keys(queryParams).reduce((acc, key) => {
            acc[key.toLowerCase()] = queryParams[key]; // Store value with lowercase key
            return acc;
        }, {});

        firstName = normalizedParams["firstname"] || "";
        name = normalizedParams["name"] || "";
        email = normalizedParams["email"] || "";
        mobile = normalizedParams["mobile"] || "";
    }

    let queryParamDataObj = {
        firstName: firstName,
        name: name,
        email: email,
        mobile: mobile
    } 

    return queryParamDataObj;
}

export const whiseEventDeletFromWhise = async (clientToken, whiseEventId) => {
    try {
        let url = "https://api.whise.eu/v1/calendars/delete";
        let headers = {
            'Authorization': `Bearer ${clientToken}`,
            'Content-Type': 'application/json'
        };
        let body = {
            "CalendarIds": [whiseEventId]
        };

        const response = await axios.delete(url, { data: body, headers: headers });
        console.log(response.data);
    }
    catch (error) {
        console.log(error);
    }
}

export const addNewWhiseEventOnWhise = async (clientToken, body) => {
    try {
        let url = "https://api.whise.eu/v1/calendars/upsert";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.post(url, body, config);
        const newWhiseEventId = response.data.calendarId;
        //console.log(newWhiseEventId);
        return newWhiseEventId;
    }
    catch (error) {
        console.log(error);
    }
}

export const checkEventStartEndTimeFromDBisAlreadyExist = async (eventSlot) => {
    let increment = 0;
    let currentEventStartDateTime = new Date(eventSlot.startDateTime);
    let currentEventEndDateTime = new Date(eventSlot.endDateTime);

    while (true) {

        let formattedStartDateTime = currentEventStartDateTime.toLocaleString('sv-SE').replace(' ', 'T');
        let formattedEndDateTime = currentEventEndDateTime.toLocaleString('sv-SE').replace(' ', 'T');

        try {
            let url = `${variables.API_URL}LocalEvents/CheckEventsFromDbBasesOnTime?estateId=${eventSlot.estateId}&calendarActionId=${eventSlot.calenderActionId}&agentId=${eventSlot.agentId}&startDateTime=${formattedStartDateTime}&endDateTime=${formattedEndDateTime}`;

            const response = await axios.get(url);
           // console.log(response.data);

            if (response.data == true) {
                increment = 1;

                currentEventStartDateTime = new Date(currentEventStartDateTime.getTime() + increment * 1000);
                currentEventEndDateTime = new Date(currentEventEndDateTime.getTime() + increment * 1000);

            } else if (response.data == false) {

                const eventDateTime = {
                    eventStartDateTime: formattedStartDateTime,
                    eventEndDateTime: formattedEndDateTime,
                    status: response.data
                }

                return eventDateTime;
                // break;
            }
        } catch (error) {
            console.log("error:", error);
            break;
        }
    }
}

export const freeSlotEventToConfirmEventHandling = async (eventBody) => {
    try {
        let url = `${variables.API_URL}LocalEvents/TobeConfirmedToConfirmedEventHandling`;

        let body = {
            "clientId": eventBody.clientId,
            "estateId": eventBody.estateId,
            "contactId": eventBody.contactId,
            "whiseEventId": eventBody.whiseEventId,
            "officeId": eventBody.officeId,
            "agentId": eventBody.agentId,
            "freeSlotToConfirmed": true,
            "contactObj": eventBody.contactObj,
            "ContactQaDocDetail": eventBody.ContactQaDocDetail,
            "eventId": eventBody.eventId
        }
        //console.log(body);
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.post(url, eventBody, config);
        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log(error);
        return error;
    }
}

export const agentEmailNotSentInfoToClient = async (whiseEventId, estateId, agentEmail, startDateTime, endDateTime, agentLanguageTranslation) => {
    try {
        let html = "";
        html += "<table width='600' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px auto;'>";
        html += "<tr>";
        html += "   <td style='text-align: center; padding: 30px 0px 50px 0px;'>";
        html += "       <img src='" + variables.AgentSiteURL + "assets/logo-placeholder.png' width='200' style='margin: 0 auto; display: block;' />";
        html += "   </td>";
        html += "</tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 20px 20px;'>";
        html += `                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px; padding: 0 20px 12px 20px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["bookingCompletedEmailFailedDesc"] : "The booking has been successfully completed (FreeSlot → To Be Confirmed). However, due to a technical issue, the email could not be sent to the agent. Please find the event details below:"}</p>`;
        html += `                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px; padding: 0 20px 8px 20px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["whiseEventId"] : "Whise Event Id"}: ${whiseEventId}</p>`;
        html += `                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px; padding: 0 20px 8px 20px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["estateId"] : "Estate Id"}: ${estateId}</p>`;
        html += `                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px; padding: 0 20px 8px 20px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["startDateTime"] : "StartDateTime"}: ${startDateTime}</p>`;
        html += `                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px; padding: 0 20px 8px 20px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["endDateTime"] : "EndDateTime"}: ${endDateTime}</p>`;
        html += "               </td>";
        html += "           </tr>";
        html += "</table>";

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        //let sendToEmails = ["", agentEmail]; //[agentEmail] //
        let sendTo = `smartcalendar-monitoring@mindfree.info; ${agentEmail}`; //agentEmail

        let subject = agentLanguageTranslation != null ? agentLanguageTranslation["bookingCompletedEmailFailedTitle"] : "Booking process is not sent email to Agent";

        let objEmail = {
            emailTo: sendTo,   // one email at a times
            body: html,
            subject: subject,
            emailType: "agent"
        };

       // console.log(objEmail);
        const url = variables.API_URL + `Email/SendEmail?`;
        const response = await axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
        console.log(response.data);

    } catch (error) {
        console.log(error);
    }
}

export const contactQuesDoucUploadDetailObj = (estateconfigurations, uploadedFiles, agentLanguage) => {

    // contact question and answer setup
    let contactQuesAnsUploadDetail = estateconfigurations != null && estateconfigurations.questions.length > 0 ?
        estateconfigurations.questions.filter(item => item.answerText !== undefined && item.answerText != "")
            .map(item => {
                const qObj = JSON.parse(item.questionDetail);
                let lang = agentLanguage || "fr-BE";
                return {
                    question: qObj[`questionTitle-${lang}`], // dynamic key
                    answerText: item.answerText
                }
            })
        :
        [];

    // contact Document upload
    let contactDocUploadDetail = uploadedFiles.urls.length > 0 ?
        uploadedFiles.urls
            .map((item, index) => {
                return {
                    title: `Doc${index + 1}`, // dynamic key
                    url: item
                }
            })
        :
        [];

    const contactQuesDocUploadDetailObj = {
        Question: contactQuesAnsUploadDetail,
        documents: contactDocUploadDetail
    }

    return contactQuesDocUploadDetailObj;
}

export const getEstateAndOfficeSetting = async (payload) => {
    try {
        let url = `${variables.API_URL}Preferences/GetEstateOrOfficeSetting?clientId=${payload.clientId}&estateId=${payload.estateId}&officeId=${payload.officeId}&actionType=${payload.actionType}&settingType=${payload.settingType}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log("get estate and office api error", error);
        return "error";
    }
}

